<template>
  <div class="all-case">
    <div class="compent-box">
      <div class="w-default">
        <h1 class="fs-xxxl text-center">全部案例</h1>
        <ul>
          <li v-for="(item,index) in items" :key="index">
            <img :src="item.imgUrl" alt />
            <h2>{{item.title}}</h2>
            <h3>{{item.detail1}}</h3>
            <p :title="item.detail2">{{item.detail2}}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          imgUrl: require("../assets/img/case/AllCase/bwg.jpg"),
          title: "深圳博物馆",
          detail1:"智慧文博解决方案",
          detail2: "深圳博物馆由展楼、工作楼、文物库和视听厅等4处独立的建筑物组成，形成一组内部功能现代化的建筑群。展楼为建筑群中心，展楼前广场宽阔，南广场所树立的铸铜雕塑《闯》是深圳市标志性的著名雕塑。视听厅在展楼东南角。"
        },
        {
          imgUrl: require("../assets/img/case/AllCase/ggg.jpg"),
          title: "深圳改革开放展览馆",
          detail1:"智慧文博解决方案",
          detail2: "深圳改革开放展览馆，位于广东省深圳市福田区福中路184 号深圳改革开放展览馆（深圳市当代艺术与城市规划馆四楼、五楼），面积 6300平方米，运用照片、实物、视频、模型、场景、雕塑和高科技手段、互动体验项目，全面、生动和立体地展现广东改革开放40年的壮阔历程和辉煌成就。"
        },
        {
          imgUrl: require("../assets/img/case/AllCase/szdx.jpg"),
          title: "深圳大学",
          detail1:"安信一体化运维平台",
          detail2: "深圳大学（Shenzhen University），简称“深大”，位于中国经济特区广东省深圳市，是由国家教育部批准设立，广东省主管、深圳市人民政府主办的综合性大学，入选广东省高水平大学重点建设高校、国家大学生文化素质教育基地、国家国际科技合作基地、国家级大学生创新创业训练计划、全国文明校园、全国首批深化创新创业教育改革示范高校，全国地方高校UOOC联盟发起单位，粤港澳高校联盟、CDIO工程教育联盟成员单位，设有研究生院，具有推荐免试研究生资格。"
        },
        {
          imgUrl: require("../assets/img/case/AllCase/szjsdx.jpg"),
          title: "深圳技术大学",
          detail1:"智慧教育解决方案",
          detail2: "深圳技术大学是广东省深圳市的一所公立应用型本科院校，面向高端产业发展需求，致力于培养高水平工程师、设计师等极具“工匠特色”的顶尖专门人才。学校是深圳市“十三五”期间重点打造的一所本科及以上层次的高水平应用技术大学，是贯彻落实市委市政府“东进战略”的具体行动  。"
        },
        {
          imgUrl: require("../assets/img/case/AllCase/dhxx.jpg"),
          title: "深圳外国语学校东海附属小学",
          detail1:"智慧教育解决方案",
          detail2: "深圳外国语学校东海附属小学创办于2000年，坐落于深圳市香蜜湖西侧，是一所环境优美、设施齐备、师资精良、特色鲜明的现代化国有民办小学。学校由广东省一级学校、全国外国语学校工作研究会理事会学校、全国现代教育实验学校——深圳外国语学校独立承办，是深圳外国语学校的小学部。"
        },
        {
          imgUrl: require("../assets/img/case/AllCase/yxxx.jpg"),
          title: "深圳市育新学校",
          detail1:"智慧教育解决方案",
          detail2: "深圳市育新学校是直属深圳市教育局领导的公办全寄宿制学校，创办于1993年。1994年、1995年，学校先后创办了“深圳市中小学德育基地”“深圳市新鹏职业高级中学”，成为集初等教育、中等职业教育和中小学生综合实践教育为一体的多功能、综合型教育机构。"
        },
        {
          imgUrl: require("../assets/img/case/AllCase/esy.jpg"),
          title: "深圳市第二实验学校",
          detail1:"安信一体化运维平台",
          detail2: "深圳市第二实验学校，创办于1989年，是深圳市教育局直属公办学校，有初、高中两个校区。学校是广东省首批国家级示范高中、广东省一级学校，广东省高中教学水平优秀学校，连续13年获深圳市高考工作卓越奖，2017年高考一本率58.3%，本科上线率97.82%，被市教育局、《南方都市报》评为深圳市2017年年度最具影响力学校。"
        },
        {
          imgUrl: require("../assets/img/case/AllCase/8.jpg"),
          title: "民防指挥部",
          detail1:"安信一体化运维平台",
          detail2: "藏品综合业务平台，包含藏品查询、修改、出入库统计，藏品类型、数量等。"
        },
        {
          imgUrl: require("../assets/img/case/AllCase/hebgydx.jpg"),
          title: "哈尔滨工业大学",
          detail1:"安信一体化运维平台",
          detail2: "哈尔滨工业大学（深圳）（Harbin Institute of Technology，Shenzhen）由哈工大与深圳市政府合作共建，是哈工大的一个校区，是广东省深圳市的一所大学。哈工大（深圳）以全日制本科生与研究生教育为主、非全日制教育为辅，是最早进驻深圳招收本科生的中国九校联盟（C9）成员、世界一流大学建设高校（A类）。"
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/_variables.scss";
.all-case {
  h1 {
    margin-bottom: 50px;
  }
  ul {
    display: flex;
    flex-wrap: wrap;
    li {
      width: 372px;
      margin-right: 42px;
      border: 1px solid #e0e0e0;
      margin-bottom: 40px;
      padding-bottom: 30px;
      img {
        height: 200px;
        width: 370px;
        object-fit: cover;
      }
      h2 {
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 30px;
        padding: 24px 20px 0 20px;
      }
      h3 {
        line-height: 1.5;
        margin-bottom: 8px;
        padding: 0 20px;
      }
      p {
        width: 100%;
        line-height: 1.5;
        color: #999999;
        padding: 0 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      &:nth-child(3n + 3) {
        margin-right: 0;
      }
    }
  }
}
</style>